<template>
  <div
    class="category-card"
    @click="hanldeClick"
  >
    <div class="title-wrap">
      <img
        :src="getImgSrc(item)"
        alt=""
        class="img"
      >
      <div>{{ `${index + 1}.${item.articleTypeName}` }}</div>
    </div>
    <div class="artcle-wrap">
      <div>数量:{{ item.count || 0 }}</div>
      <div
        class="dot"
        v-if="item.existNoRead"
      />
      <img
        src="@/assets/img/learn-center/icon-next.png"
        alt=""
        class="img"
      >
    </div>
  </div>
</template>

<script >
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      imgUrlOptions: {
        'APP_AND_SYSTEM_OPERATION_GUIDE': 'icon-app.png',
        'SERVICE_PROCESS_NOTES': 'icon-notes.png',
        'TYPICAL_COMPLAINTS_AND_NEGATIVE_REVIEWS': 'icon-reviews.png',
        'SERVICE_REQUIREMENTS_AND_REPORTING_RULES': 'icon-service-rule.png',
        'PHOTO_REVIEW_AND_SETTLEMENT_RULES': 'icon-photo-rule.png',
        'SERVICE_LEVEL_TESTING_AND_ASSESSMENT': 'icon-assmessment.png',
        'HOLIDAYS_AND_SPECIAL_WEATHER_NOTICES': 'icon-weather.png',
        'OTHER_NOTICES': 'icon-other.png'
      }
    };
  },
  methods: {
    hanldeClick() {
      this.$emit('click', this.item);
    },
    getImgSrc(item) {
      if (item && item.articleType) {
        const url = this.imgUrlOptions[item.articleType];
        if (url) {
          return require(`@/assets/img/learn-center/${url}`);
        }
      }
      return require('@/assets/img/learn-center/icon-other.png');
    }
  }
};

</script>

<style lang="scss" scoped>
  .category-card {
    height: 72px;
    background: #FFFFFF;
    border-radius: 8px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #383838;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 0 8px 0 12px;

    .artcle-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #999999;
      font-weight: 400;
      .dot {
        background-color: #F32222;
        margin-right: 4px;
        margin-left: 4px;
        width: 8px;
        height: 8px;
        border-radius: 4px;
      }

      .img {
      width: 12px;
      height: 12px;
      padding-left: 4px;
    }

    }

    .title-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      .img {
        margin-right: 12px;
        width: 36px;
        height: 36px;
      }
    }
  }
</style>
